import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks';
import { InvoiceManagement } from 'pages/invoices';

export const InvoiceManagementRoute = () => {
  const { isAdmin, isExpired } = useCanAccess('invoices');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <InvoiceManagement />
  ) : (
    <Unauthorized />
  );
};
